










































































































































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetMancodeList, InsertMancode, UpdateMancodeById, DeleteMancode, GetUtcodeList} from '../../../api/specialDictionary'
import {GetProvinceList, GetCityByProvList} from '../../../api/basicDictionary'
import {GetPinYin, GetWuBi} from '../../../api/sys'
import {GetListByCode} from '../../../api/configureDictionary'

@Component
export default class Country extends AbpBase {
	cancel(){
		this.dialogFormVisible = false
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.dialogFormVisible = false;
			(this.$refs.form as any).resetFields()
			this.getData()
		}
	}
	columns = [
		{
			key: 'manName',
			title: '人员姓名'
		},
		{
			key: 'jobNum',
			title: '员工工号'
		},
		{
			key: 'manPY',
			title: '拼音助记符'
		},
		{
			key: 'manWB',
			title: '五笔助记符'
		},
		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: 'spare',
			title: '备注'
		},
		{
			key: '',
			width: 190,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	types = []  //人员类型下拉
	uts = []  //部门下拉
	provs = [] //省下拉
	cities = [] //市下拉
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm: any = {
		manPY:'',
		manWB:''
	}
	dialogFormVisible = false
	dialogFormLabelWidth = '100px'
	tableTotalSize = 0
	tableData = []
	tableLoading = false
	created() {
		this.getData()
		this.getSelects()
	}
	async getCode(val: any){
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.manPY = res1
		this.dialogForm.manWB = res2
	}
	createCounty() {
		this.dialogTitle = '新增人员'
		this.dialogForm = {
			status:true,
			manPY:'',
			manWB:'',
			age:null
		}
		this.dialogFormVisible = true
	}
	identityCardInput(val: any){
		if (val.length === 18) {
			let year = val.substring(6,10)
			let month = val.substring(10,12)
			let day = val.substring(12,14)
			this.dialogForm.birthday = `${year}-${month}-${day}`
			this.dialogForm.age = new Date().getFullYear() - year + 1
		}
	}
	deptChange(val: any){
		this.dialogForm.deptType = val.id
		this.dialogForm.deptTypeName = val.text
	}
	async provChange(){
		// this.dialogForm.provName = val.provName
		let id
		for(let i in this.provs) {
			if ((this.provs[i] as any).provName === this.dialogForm.provName) {
				id = (this.provs[i] as any).id
			}
		}
		let res = await GetCityByProvList({id: id})
		this.cities = res
	}
	private async getData() {
		this.tableLoading = true
		let res = await GetMancodeList({
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}
	async getSelects(){
		let res = await GetListByCode({input:'021'})
		this.types = res
		let res1 = await GetUtcodeList({QueryString:'',SkipCount:1,MaxResultCount:10000})
		this.uts = res1.items
		let res2 = await GetProvinceList({QueryString:'',SkipCount:1,MaxResultCount:10000})
		this.provs = res2.items
	}
	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.dialogTitle = '编辑人员'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}
	async del(row: any){
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteMancode({Id: row.id})
			this.getData()
		}).catch(() => {

		});

	}
	async confirm(){
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (this.dialogTitle === '新增人员') {
					let res = await InsertMancode(this.dialogForm)
				} else if (this.dialogTitle === '编辑人员') {
					let res = await UpdateMancodeById(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})
	}
	birthdayChange(){
		let currentYear = new Date().getFullYear()
		let year = (this.dialogForm.birthday as Date).getFullYear()
		this.dialogForm.age = currentYear - year + 1
	}
	rules = {
		manName:[{required: true, message: '请输入内容', trigger: 'blur'}],
		manPY:[{required: true, message: '请输入内容', trigger: 'blur'}],
		manWB:[{required: true, message: '请输入内容', trigger: 'blur'}],
	}
	pageChange(val: any){
		this.page = val
		this.getData()
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/personnel/index.vue